<template>
  <section class="loginContainer">
    <div class="loginInner">
      <div class="login_header">
        <div class="login_logo">
          <img src="./images/96_1.png" class="logoImg"/>
        </div>
        <h2 class="login_logo">欢迎登录{{title}}</h2>
      </div>
      <div class="login_content">
        <form @submit.prevent="login">
          <div v-show="isMessage">
            <section class="login_message">
              <span class="prefix">+86</span>
              <input type="tel" maxlength="11" class="phone" name="phone" placeholder="请输入手机号" v-model="phone">
            </section>
            <section class="login_verification">
              <input type="tel" maxlength="8" placeholder="请输入验证码" v-model="code">
              <button :disabled="!isPhone" class="get_verification" :class="{is_phone:isPhone}" @click.prevent="getCode">
                  {{computeTime>0 ? `已发送(${computeTime}s)`:'获取验证码'}}</button>
            </section>
          </div>
          <button class="login_submit" @click.prevent="RegisterTest">注册</button>
        </form>
      </div>
      <a href="javascript:" class="go_back">
        <i class="iconfont icon-jiantou2"></i>
      </a>
    </div>
  </section>
</template>

<script>
  import { Toast } from 'vant';
  import envJS from '../../common/js/env'
  import {reqSendCode, reqRegister} from '../../api'
	export default {
    name:"register",
	  data() {
	    return {
		title:envJS.baseTitle,
        isMessage:true,// true短信登录 false密码登录
        computeTime:0,//计时的时间
        phone:'',//短信手机号
        pwdPhone:'',//密码手机号
        showPwd: false,//是否显示密码
        password:'',//密码
        code:'',//短信验证码
        loginBthText:'登录'
      }
    },
    computed: {
      isPhone () {
        return /^1\d{10}$/.test(this.phone)
      },
      isPwdPhone () {
        return /^1\d{10}$/.test(this.pwdPhone)
      }
    },
    methods:{
      //异步获取短信验证码
      async getCode () {
        //如果当前没有计时
        if(!this.computeTime){
          //启动倒计时
          this.computeTime = 60
          const interval = setInterval(() => {
            this.computeTime--
            if(this.computeTime<=0){
              //停止计时
              clearInterval(interval)
            }
          },1000)
          //发送ajax请求（向指定手机号发送验证码短信）
          let SendCode = {
            telephone:this.phone
          }
          // 获取短信验证
          await reqSendCode(SendCode).then(res => {
          if(res.success){
            Toast.success({message:'发送成功！',className:'apiLoading'});
          }else {
            Toast.fail({message:res.msg,className:'apiLoading'});
          }
          })
        }
      },
      //异步登录验证
      async RegisterTest () {
        let result
        //前台表单验证
        if(this.isMessage){
          const {phone, isPhone, code} = this
          if(!this.phone){
            Toast.fail({message:'请输入正确手机号！',className:'apiLoading'});
            return false
          }else if(!/^\d{4}$/.test(code)){
            //验证码不对
            Toast.fail({message:'请输入正确验证码！',className:'apiLoading'});
            return false
          }
          let loginData = {
            telephone:this.phone,
            validCode:this.code,
            openId:this.$cookies.get('wxUserInfo').openid
          }
          await this.RegisterApi(loginData)
        }
      },
      RegisterApi (loginData) {
        reqRegister(loginData).then(res => {
          if(res.success){
            Toast.success({message:'注册并登录成功！',className:'apiLoading'});
            this.$cookies.remove('userInfo');
            this.$cookies.set('userInfo',res.data);
            this.$router.push({
              path:'/autpayment',
              name:'autpayment'
            })
          }else {
            Toast.fail({message:res.msg,className:'apiLoading'});
          }
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixins.styl"
  .loginContainer
    width 100%
    height 100%
    background #fff
    .loginInner
      padding-top 60px
      width 73%
      margin 0 auto
      .login_header
        .login_logo
          font-size 54px
          font-weight bold
          color #000000
          text-align center
          padding 10px 0px 50px
        .login_header_title
          padding 40px 0px 20px
          text-align center
          >a
            color #333
            font-size 20px
            padding-bottom 8px
            &:first-child
              margin-right 40px
            &.on
              color #ff6d02
              font-weight 700
              border-bottom 2px solid #ff6d02
      .login_content
        >form
          >div
            input
              width 100%
              height 100%
              padding-left 20px
              box-sizing border-box
              border 0px
              border-radius 4px
              outline 0
              font 400 28px Arial
            input::-webkit-input-placeholder
              color #cccccc
            input::-moz-placeholder
               color #cccccc   /* Mozilla Firefox 19+ */
            input:-moz-placeholder /* Mozilla Firefox 4 to 18 */
              color #cccccc
            input:-ms-input-placeholder /* Internet Explorer 10-11 */
              color #cccccc
            .login_message
              position relative
              margin-top 16px
              height 48px
              font-size 14px
              background #fff
              padding-bottom 15px
              border-bottom 1px solid #eaeaea
              vertical-align middle
              &:focus
                border-bottom 1px solid #02a774
              .prefix
                font-size 34px
                text-align center
                width 14%
                padding-right 5px
                height 44px
                display inline-flex
                display -webkit-inline-flex
                border-right 1px solid #eaeaea
                flex-direction column
              .phone
                flex-direction column
                width 83%
              .captcha
                width 70%
                align-items center
                vertical-align middle
              .captchaImg
                width 28%
                height auto
                vertical-align middle
            .login_verification
              position relative
              margin-top 16px
              height 48px
              font-size 14px
              background #fff
              padding-bottom 15px
              border-bottom 1px solid #eaeaea
              .switch_button
                font-size 18px
                border 1px solid #ddd
                border-radius 15px
                transition background-color .3s,border-color .3s
                padding 0 6px
                width 60px
                height 30px
                line-height 16px
                color #fff
                position absolute
                top 50%
                right 10px
                transform translateY(-50%)
                &.off
                  background #fff
                  .switch_text
                    float right
                    line-height 30px
                    color #dddddd
                    &.on
                      float left
                &.on
                  background #02a774
                >.switch_circle
                  //transform translateX(27px)
                  position absolute
                  top -1px
                  left -1px
                  width 30px
                  height 30px
                  border 1px solid #ddd
                  border-radius 50%
                  background #fff
                  box-shadow 0 2px 4px 0 rgba(0,0,0,.1)
                  transition transform .3s
                  &.right
                    transform translateX(42px)
              &:focus
                border-bottom 1px solid #02a774
              .get_verification
                position absolute
                top 50%
                right 10px
                transform translateY(-50%)
                border 0
                color #ccc
                font-size 28px
                background transparent
                outline none
                &.is_phone
                  color black
            .login_hint
              margin-top 12px
              color #999
              font-size 14px
              line-height 20px
              >a
                color #02a774
          .login_submit
            display block
            width 100%
            height 90px
            margin-top 135px
            border-radius 45px
            background #ff6d02
            color #fff
            text-align center
            font-size 32px
            line-height 90px
            border 0
            outline none
        .about_us
          display block
          font-size 12px
          margin-top 20px
          text-align center
          color #999
      .go_back
        position absolute
        top 5px
        left 5px
        width 30px
        height 30px
        >.iconfont
          font-size 20px
          color #999
</style>



// WEBPACK FOOTER //
// src/pages/Login/Register.vue